import { render, staticRenderFns } from "./basic_display_details.vue?vue&type=template&id=3ebd2559&scoped=true&"
import script from "./basic_display_details.vue?vue&type=script&lang=js&"
export * from "./basic_display_details.vue?vue&type=script&lang=js&"
import style0 from "./basic_display_details.vue?vue&type=style&index=0&id=3ebd2559&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebd2559",
  null
  
)

export default component.exports